export default "__VITE_ASSET__BsMC6eyR__"